import { CollapsibleCard } from '@teamsnap/snap-ui';
import { CollapsibleCardSkeleton } from 'components/common';
import { LoadingType } from 'hooks/postRegEditDrawer';
import * as React from 'react';
import { usePostRegEditDrawer } from '../../../../../hooks/postRegEditDrawer/usePostRegEditDrawer';
import { FormQuestion } from '../types';
import { FormQuestionInput } from './FormQuestionInput';

const QuestionList = ({ questions }: { questions: FormQuestion[] }) => (
  <div className="sui-flex sui-flex-col sui-justify-between sui-gap-1">
    {questions?.map((question) => (
      <FormQuestionInput key={question.id} question={question} />
    ))}
  </div>
);

const FeeRelatedCardContent = React.memo(
  ({ questions }: { questions?: FormQuestion[] }) => (
    <fieldset>
      <p className="sui-body sui-text-gray-60 sui-mb-2">
        You will have the option to make any necessary balance adjustments after
        clicking "Review updates."
      </p>
      <QuestionList questions={questions} />
    </fieldset>
  )
);

const AdditionalCardContent = React.memo(
  ({ questions }: { questions?: FormQuestion[] }) => (
    <fieldset>
      <QuestionList questions={questions} />
    </fieldset>
  )
);

const PostRegEditForm = () => {
  const { formStructure, loading } = usePostRegEditDrawer();

  return (
    <div className="sui-w-full sui-flex-1">
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        noValidate
      >
        <input type="submit" className="sui-hidden" />

        {loading[LoadingType.GetEditableQuestions] ? (
          <CollapsibleCardSkeleton />
        ) : (
          <div className="sui-flex sui-flex-col sui-gap-4">
            <CollapsibleCard.Root isDefaultOpen>
              <CollapsibleCard.Header title="Fee-related Questions" />
              <CollapsibleCard.Content>
                <FeeRelatedCardContent
                  questions={formStructure?.feeRelatedQuestions}
                />
              </CollapsibleCard.Content>
            </CollapsibleCard.Root>
            {formStructure?.additionalQuestions?.length > 0 && (
              <CollapsibleCard.Root isDefaultOpen={false}>
                <CollapsibleCard.Header title="Additional Questions" />
                <CollapsibleCard.Content>
                  <AdditionalCardContent
                    questions={formStructure?.additionalQuestions}
                  />
                </CollapsibleCard.Content>
              </CollapsibleCard.Root>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

export default PostRegEditForm;
